import React from "react";
import image from '../../../images/situation/maten/kozijn/A.gif'
import PropTypes from "prop-types";

MaatA.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function MaatA(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u invullen wat de maat is tussen het gesloten luik en het kozijn, in milimeters.<br/>
        </div>
        <div className="phone-situation-description">
            Deze maat zal meestal 2 of 3 mm zijn. Alleen als bijvoorbeeld ramen of scharnieren er buiten uitsteken, zal deze maat groter zijn.
            <br />
            Houd ook rekening met eventuele deurkrukken.
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de maat in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}